export const collectionsLightTheme = {
  '--collections-bgc-1': '#f8f8f8',
  '--collections-bgc-2': 'linear-gradient(341deg, #5c8dff 9%, #65d5ff 83%)',
  '--collections-bgc-3': 'transparent',
  '--collections-bgc-4': '#9fa7b3',
  '--collections-font-c-1': '#333',
  '--collections-font-c-2': '#666',
  '--collections-font-c-3': '#65d5ff',
  '--collections-font-c-4': '#fff',
  '--collections-font-c-5': '#65d5ff',
  '--collections-border-c-1': '#eee',
  '--collections-border-c-2': '#65d5ff',
}
export const collectionsDarkTheme = {
  '--collections-bgc-1': '#23262f',
  '--collections-bgc-2': 'linear-gradient(341deg, #5c8dff 9%, #65d5ff 83%)',
  '--collections-bgc-3': 'transparent',
  '--collections-bgc-4': 'rgba(255, 255, 255, 0.75)',
  '--collections-font-c-1': '#fff',
  '--collections-font-c-2': '#9fa7b3',
  '--collections-font-c-3': '#65d5ff',
  '--collections-font-c-4': '#fff',
  '--collections-font-c-5': '#fff',
  '--collections-border-c-1': '#222e3d',
  '--collections-border-c-2': '#ffffff',
}
